import {
  MenuItem,
  OuiButtonComponent,
  OuiMenuComponent,
  OuiRowComponent,
  OuiSymbolComponent,
  OuiTextComponent,
} from '@aiz-gl/omni-ui';
import { Component, computed, inject } from '@angular/core';
import { AuthService } from '../../services/auth/auth.service';
import { RegionService } from '../../services/region/region.service';

@Component({
  selector: 'app-user-menu',
  imports: [
    OuiButtonComponent,
    OuiMenuComponent,
    OuiRowComponent,
    OuiTextComponent,
    OuiSymbolComponent,
  ],
  templateUrl: './user-menu.component.html',
})
export class UserMenuComponent {
  auth = inject(AuthService);
  regions = inject(RegionService);

  menuItems: MenuItem[] = [
    {
      label: 'Sign-Out',
      symbolName: 'logout',
      action: () => this.auth.signOut(),
    },
  ];

  regionMenuItems = computed<MenuItem[]>(() => {
    const availableRegions = this.regions.availableRegions(
      this.auth.authProfile(),
    );

    return availableRegions().map((r) => ({
      label: r.label,
      symbolName: 'public',
      action: () => this.regions.selectRegion(r.code),
    }));
  });
}
